<template>
  <div class="cardTotal">
    <div class="cardContainer">
      <div class="navLunbo">
        <!-- <ul>
          <li
            v-for="(item, index) in NavList"
            :key="index"
            @click="change(index)"
          >
            <div class="inLi">
              <div class="imgIcon">
                <img :src="item.imgSrc" alt="" />
              </div>
              <div class="p" :class="{ active: index == current }">
                {{ item.name }}
              </div>
              <div
                :class="{ xiahuaxian: index == current }"
                v-if="index == current"
              ></div>
            </div>
          </li>
        </ul> -->
        <van-tabs v-model="current" color="#338989">
          <van-tab v-for="(item, index) in NavList" :key="index">
            <template #title>
              <div class="inLi">
                <div class="imgIcon">
                  <img :src="item.imgSrc" alt="" />
                </div>
                <div class="p" :class="{ active: index == current }">
                  {{ item.name }}
                </div>
                <!-- <div :class="{ xiahuaxian: index == current }"></div> -->
              </div></template
            >
          </van-tab>
        </van-tabs>
      </div>
      <div class="content">
        <div class="content1" v-show="current == 0">
          <div class="jiesao">
            <div class="typeTitle">
              <img src="../assets/images/kuntong.png" alt="" class="titleImg" />
            </div>

            <div class="kuntong2">
              <img src="../assets/images/kuntong2.png" alt="" />
            </div>

            <div class="word">
              昆通卡是针对非昆山籍人员推出的只包含电子钱包应用功能的智能IC卡，依托于昆通卡这一现代电子载体，广大用户将充分享受到“一卡在手神州行，为民利民昆山通”的现代化生活。
            </div>
          </div>
          <div class="linyu">
            <img src="../assets/images/linyu.png" alt="" />
          </div>
          <div class="zhuti">
            <img src="../assets/images/zhuti.png" alt="" />
          </div>
          <div class="imgList">
            <img src="../assets/images/kuntongs.png" alt="" />
          </div>
        </div>
        <div class="content2" v-show="current == 1">
          <div class="titleImg">
            <img src="../assets/images/yixing.png" alt="" />
          </div>
          <div class="linyu">
            <img src="../assets/images/linyu.png" alt="" />
          </div>
          <div class="leftSanjiao">
            <div class="dishiniTitle">
              <img src="../assets/images/dishini1.png" alt="" />
            </div>
            <div class="dishiniWord">
              为满足广大市民日益增长的个性化需求,昆山市民卡有限公司特推出迪士尼主题系列异形卡，本次发售的迪士尼版权卡采用的是住建部、交通部双密钥应用，为全国首张双密钥迪士尼版权卡，互联互通城市规模巨大，大大提高了昆山市民出行便捷程度。
            </div>
            <div class="dishiniCard">
              <img src="../assets/images/dishini2.png" alt="" />
            </div>
            <div class="tangyoubeiTitle">
              <img src="../assets/images/tangyou1.png" alt="" />
            </div>

            <div class="tangyoubeiWord">
              2016年为纪念汤尤杯在昆山举办，推出了汤尤杯纪念卡套装，分为2张吉祥物“昆昆”和“山山”，以及汤尤杯标准卡1张。
            </div>
          </div>

          <div class="tangyoubeiCard">
            <img src="../assets/images/tangyou2.png" alt="" />
          </div>
          <div class="rightSanjiao">
            <div class="zhonghuanTitle">
              <img src="../assets/images/zhonghuan1.png" alt="" />
            </div>
            <div class="zhonghuanWord">
              2016年5月为纪念卡昆山中环开通1周年，推行了3个版面的中环纪念卡。
            </div>
            <div class="zhonghuanCard">
              <img src="../assets/images/zhonghuan2.png" alt="" />
            </div>
            <div class="xuancaiTitle">
              <img src="../assets/images/xuanpei1.png" alt="" />
            </div>
          </div>

          <div class="xuancaiWord">
            2017年为丰富昆通卡种类，推行昆通卡智能手环，手环集合了小额电子钱包与智能手环功能。
          </div>
          <div class="xuancaiCard">
            <img src="../assets/images/xuanpei2.png" alt="" />
          </div>
          <div class="yixinkaTitle">
            <img src="../assets/images/yixing1.png" alt="" />
          </div>
          <div class="yixingkaWord">
            2015年，首次对外出售4款异形卡（方块、水滴、旗袍、班尼熊）以及Iphone6，Iphone6PLUS手机壳卡。
          </div>
          <div class="yixinCard">
            <img src="../assets/images/yixing2.png" alt="" />
          </div>
        </div>
        <div class="content3" v-show="current == 2">
          <div class="shimingCardTitle">
            <img src="../assets/images/nongshangTitle.png" alt="" />
          </div>
          <div class="cardImg">
            <img src="../assets/images/nongshangCard.png" alt="" />
          </div>
          <div class="cardWord">
            2016年，昆山市民卡有限公司携手昆山市人力资源和社会保障局、昆山农村商业银行，倾力升级昆山市民卡，正式推出新社保卡暨全新市民卡，开启昆山市民“双卡智慧生活”。
            此次昆山市民卡升级，将功能一分为二；新社保卡集成了医保以及金融两项属性，面向所有参加社会保障的参保对象发放，为广大市民提供专业、安全的社保服务。
          </div>
          <div class="linyu">
            <img src="../assets/images/linyu.png" alt="" />
          </div>
          <div class="zhuti">
            <img src="../assets/images/zhuti.png" alt="" />
          </div>
          <div class="zhutiCard">
            <img src="../assets/images/nongshangcards.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
export default {
  mounted() {
    this.getHeight();
    document.querySelector("body").setAttribute("style", "overflow:hidden;");
    document.body.addEventListener("touchstart", function () {});
  },
  destroyed() {
    document.querySelector("body").setAttribute("style", "overflow:auto;");
  },
  data() {
    return {
      NavList: [
        {
          name: "昆通卡",
          imgSrc: require("../assets/images/card1.png"),
        },
        {
          name: "异型卡",
          imgSrc: require("../assets/images/card2.png"),
        },
        {
          name: "农商行市民卡",
          imgSrc: require("../assets/images/card3.png"),
        },
      ],
      current: 0,
    };
  },
  methods: {
    change(index) {
      this.current = index;
      console.log(1);
    },
    getHeight() {
      let a = window.screen.availHeight;

      let b =
        document.querySelector(".content").offsetTop -
        document.documentElement.scrollTop;

      document.querySelector(".content").style.height = a - b + "px";
    },
  },
};
</script>

<style lang="scss" scoped>
.cardContainer {
  width: 100%;
  // height: 19.125rem;
  background-image: url("../assets/images/cardtypebg.png");
  background-repeat: no-repeat;
  background-size: contain;
  padding: 10.375rem 2rem;
  background-color: #eef4f6;

  .content {
    overflow: auto;
    margin-top: 1.25rem;
    padding-bottom: 9.375rem;
  }
}

.navLunbo {
  width: 100%;
  height: auto;
  padding-top: 1.875rem;
  // margin-top: 5.25rem;
  background-color: #ffffff;
  z-index: 1000;
  font-size: 1.75rem;
  color: #19212a;
  border-radius: 1rem;
  ::v-deep .van-tabs__wrap {
    height: inherit;
    .van-tabs__line {
      bottom: 0;
    }
  }
  ul {
    display: flex;
    justify-content: space-between;
    white-space: nowrap;
    overflow: auto;
    padding: 0 4.75rem 0 4.75rem;

    li {
      width: 7.75rem;
      display: flex;
      justify-content: center;
    }
  }
  .imgIcon {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 6rem;
      height: 6rem;
    }
  }

  .p {
    text-align: center;
    letter-spacing: 1px;
    font-size: 1.75rem;
    color: #878787;
    white-space: nowrap;
    margin-top: 0.625rem;
  }
  // .xiahuaxian {
  //   height: 0.5rem;
  //   background: #338989;
  //   border-radius: 0.5rem;
  //   margin-top: 1.25rem;
  // }
  .active {
    color: #338989;
    font-size: 1.75rem;
    color: #4e4e4e;
    font-weight: bold;
  }
}

.content1 {
  border-radius: 1rem;
  background-color: #ffffff;

  padding: 4rem 2rem;

  .typeTitle {
    display: flex;
    justify-content: center;
    margin-right: 3rem;

    .titleImg {
      width: 11.875rem;
      height: 2.875rem;
    }
  }

  .kuntong2 {
    margin-top: 3rem;
    display: flex;
    justify-content: center;

    img {
      width: 30.25rem;
      height: 22.75rem;
    }
  }

  .word {
    border-radius: 1rem;
    padding: 3.625rem 2.625rem 2.875rem 2.625rem;
    background-color: #eff9f7;
    font-size: 1.875rem;
    color: #338989;
    letter-spacing: 1px;
    line-height: 3.75rem;
  }

  .linyu {
    margin-top: 1.75rem;

    img {
      width: 38.875rem;
    }
  }

  .zhuti {
    display: flex;
    justify-content: center;
    margin-top: 4rem;

    img {
      width: 23.5rem;
      height: 2.875rem;
    }
  }

  .imgList {
    display: flex;
    margin-top: 2.25rem;
    justify-content: center;

    img {
      width: 34.5rem;
      height: 118.625rem;
    }
  }
}

.content2 {
  background-color: #ffffff;

  padding: 4rem 2rem;

  //   .containerBg{
  //     width: 100%;
  //     height: 69.5rem;
  //     background-image: url('../assets/images/S1.png');
  //     position: absolute;
  //     left: 0;
  //     top: 0;
  //   }
  .titleImg {
    display: flex;
    justify-content: center;
    margin-right: 3rem;

    img {
      width: 11.875rem;
      height: 3.25rem;
    }
  }

  .linyu {
    margin-top: 1.75rem;

    img {
      width: 38.875rem;
      height: 28.25rem;
    }
  }

  .leftSanjiao {
    background-image: url("../assets/images/S1.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .dishiniTitle {
      display: flex;
      justify-content: center;

      img {
        width: 11.25rem;
        height: 9.625rem;
      }
    }

    .dishiniWord {
      // width: 37.625rem;
      // height: 21.25rem;
      font-size: 1.875rem;
      color: #555555;
      line-height: 3.75rem;
    }

    .dishiniCard {
      img {
        width: 38.875rem;
        height: 38.625rem;
      }
    }
  }

  .tangyoubeiTitle {
    img {
      width: 9.375rem;
      height: 9.625rem;
    }
  }

  .tangyoubeiWord {
    font-size: 1.875rem;
    color: #555555;
    line-height: 3.75rem;
  }

  .tangyoubeiCard {
    margin-top: 2.125rem;

    img {
      width: 38.875rem;
      height: 95.375rem;
    }
  }

  .rightSanjiao {
    background-image: url("../assets/images/S2.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    // background-position: 0 7.625rem;

    .zhonghuanTitle {
      display: flex;
      justify-content: center;

      img {
        width: 13.125rem;
        height: 9.625rem;
      }
    }

    .zhonghuanWord {
      font-size: 1.875rem;
      color: #555555;
      line-height: 3.75rem;
    }

    .zhonghuanCard {
      display: flex;
      justify-content: center;
      margin-top: 1.75rem;

      img {
        width: 37.625rem;
        height: 38.625rem;
      }
    }
  }

  .xuancaiTitle {
    display: flex;
    justify-content: center;
    margin-top: 2.25rem;

    img {
      width: 7.5rem;
      height: 9.625rem;
    }
  }

  .xuancaiWord {
    font-size: 1.875rem;
    color: #555555;
    line-height: 3.75rem;
  }

  .xuancaiCard {
    img {
      width: 40rem;
      height: 20.75rem;
    }
  }

  .yixinkaTitle {
    display: flex;
    justify-content: center;

    img {
      width: 5.625rem;
      height: 9.625rem;
    }
  }

  .yixingkaWord {
    font-size: 1.875rem;
    color: #555555;
    line-height: 3.75rem;
  }

  .yixinCard {
    display: flex;
    justify-content: center;
    margin-top: 4.5rem;

    img {
      width: 34.75rem;
      height: 38.125rem;
    }
  }
}

.content3 {
  background-color: #ffffff;

  padding: 4rem 2rem;

  .shimingCardTitle {
    display: flex;
    justify-content: center;
    margin-right: 3rem;

    img {
      width: 18.375rem;
      height: 3.25rem;
    }
  }

  .cardImg {
    display: flex;
    justify-content: center;
    margin-top: 2.5rem;

    img {
      width: 29.375rem;
      height: 22.75rem;
    }
  }

  .cardWord {
    padding: 2.5rem 2rem;
    background: #eff9f7;
    border-radius: 1rem;
    font-size: 1.875rem;
    line-height: 3.75rem;
    color: #338989;
  }

  .linyu {
    margin-top: 1.75rem;

    img {
      width: 38.875rem;
      height: 28.25rem;
    }
  }

  .zhuti {
    display: flex;
    justify-content: center;
    margin-top: 4rem;

    img {
      width: 23.5rem;
      height: 2.875rem;
    }
  }

  .zhutiCard {
    img {
      width: 37.625rem;
      height: 100.5rem;
    }
  }
}
</style>